import { Box, IconButton, Typography } from '@mui/material';
import useFindScanLazy from '@src/adapters/hooks/scans/useFindScanForView';
import { useCallback, useEffect, useState } from 'react';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { pdfjs } from 'react-pdf';
import ScanViewDTO from '@src/adapters/dto/scan/ScanViewDTO';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ScanView from './ScanView';

interface Props {
  id: string;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function Scan({ id }: Props) {
  const { execute: find } = useFindScanLazy();
  const [scan, setScan] = useState<ScanViewDTO>();
  const [viewOpen, setViewOpen] = useState(false);

  const findScan = useCallback(() => {
    find({
      id,
    }).then((result) => {
      if (result.scan) {
        setScan(result.scan);
      }
    });
  }, [find, id]);

  useEffect(() => {
    findScan();
  }, [findScan]);

  return (
    <>
      <Box
        sx={(theme) => ({
          padding: `${theme.spacing(2.5)} 0 ${theme.spacing(2)} ${theme.spacing(
            2
          )}`,
          borderBottom: '1px solid #E6E7E9',
          display: 'flex',
          alignItems: 'center',
        })}>
        <Typography variant="body1" sx={{ width: '80%' }}>
          {scan?.originalFilename}
        </Typography>
        <Box>
          <IconButton
            aria-label="logout"
            onClick={() => setViewOpen((prev) => !prev)}
            size="large">
            <VisibilityIcon />
          </IconButton>
        </Box>
      </Box>
      {scan && viewOpen && (
        <ScanView
          isOpen={viewOpen}
          url={scan.fileURL}
          originalFileName={scan.originalFilename}
          close={() => setViewOpen(false)}
        />
      )}
    </>
  );
}

export default Scan;
